module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, undefined) {
	'use strict';

	fox.registerWidget('Easy_Form_Validator', {
		configure: function () {
			this._formEvents = ['submit', 'formElementsCreated', 'valueChange'];
			this._hangClassLocation = ['this', 'parentNode'];

			this.registerOptions('', {
				errorClass: 'error',
				hangClassLocation: 'this',
				defaultValidator: [{
					validator: 'length',
					options: {min: 2},
					message: 'Minimum 2 letters'
				}]
			});
		
			this.callParent('configure', arguments);
		},

		init: function () {
			this._requiredFields = this.requireOption('requiredFields');
			this._processing = true;
			this._validator = new fox.Validator();

			this.checkRequiredFields();

			this.hook('wrappSubmit', this.requireOption('formWidget'), 'onStartSubmit', 'validate');

			this.callParent('init', arguments);
		},

		running: function () {
			var fn;

			this._form = this.rwom1(this.getOption('formWidget'));

			fox.each(this._formEvents, function (eventName) {
				fn = this._fName(eventName);

				if (this[fn] &&
					fox.isFunction(this[fn])) {
					this.handleEvent(this._form, eventName, fn);
				}
			}, this);

			this.callParent('running', arguments);
		},

		checkRequiredFields: function () {
			if (!fox.isObject(this._requiredFields) &&
				!fox.isArray(this._requiredFields)) {
				this._processing = false;

				fox.exception('Required fields must be array or object type.');
			}
		},

		_fName: function (value) {
			return '_function_' + value;
		},

		validate: function () {
			return this._validate();
		},

		_validate: function (alias) {
			var 
				widget,
				wValue,
				v;

			v = function (_alias) {
				widget = this._form.getEmbeddedWidget(_alias);

				this._validator._clearErrors(_alias);

				if (widget) {
					this.resetElementError(widget);
					wValue = (fox.isEmpty(widget.getValue())) ? '' : widget.getValue();
					this._validator.validate(widget.getAlias(), wValue);
				} else {
					this._validator.validate(_alias, '');
				}
			};

			if (!this._processing) {
				console.log('Skipping form validation...');
				
				return true;
			}

			if (alias === undefined) {
				fox.each(this._requiredFields, v, this);
			} else {
				v.call(this, alias);
			}

			return this._validator.isValid() || this._returnNotValid();
		},

		_returnNotValid: function () {
			this.dispatchEvent('formNotValid', {
				msg: this._validator.getFieldFirstMessage(),
				errorStack: this._validator.getErrors()
			});

			this.hangStyle();

			return false;
		},

		_prepareValidators: function () {
			var widget, currentValidation;

			fox.each(this._requiredFields, function (val) {
				widget = this._form.getEmbeddedWidget(val);

				if (widget) {
					if (widget.getOption('validateOnChange') === true) {
						this.handleEvent(widget, 'valueChanged', fox.bind(function (p, _widget) {
							var	res, a = _widget.alias;
							res = this._validator.validate(a, _widget.getValue);
							if (!res) {
								var o = {};
								o[a] = this._validator.getErrors()[a];
								this.dispatchEvent('formNotValid', {
									msg: this._validator.getFieldFirstMessage(),
									errorStack: o
								});
								this.hangStyle(a);
							} else {
								this.hangStyle(a, true);
							}
						}, this));
					}

					currentValidation =  widget.getOption('validate') || this.getOption('defaultValidator');

					if (currentValidation.length) {
						fox.each(currentValidation, function (val) {
							this._validator.addRule(widget.getAlias(), val);
						}, this);
					}
				} else {
					currentValidation = this._form.getOption('formElements.' + val + '.validate') || this.getOption('defaultValidator');

					if (currentValidation.length) {
						fox.each(currentValidation, function (validator) {
							this._validator.addRule(val, validator);
						}, this);
					}
				}
			}, this);
		},

		hangStyle: function (alias, success) {
			var srcNode, widget;

			if (alias === undefined) {
				fox.each(this._validator.getErrors(), function (val, alias) {
					if ((widget = this._form.getEmbeddedWidget(alias))) {
						srcNode = this.getLocationNode(widget);
						
						fox.dom.addClass(this.getOption('errorClass'), srcNode);
					}

				}, this);
			} else {
				if ((widget = this._form.getEmbeddedWidget(alias))) {
					srcNode = this.getLocationNode(widget);
					
					fox.dom.addClass(success === true && widget.getOption('exchangeErrorClass') && this.getOption('successClass') ? this.getOption('successClass') : this.getOption('errorClass'), srcNode);
				}
			}
		},

		getLocationNode: function (widget) {
			var location, src, childW;

			if (widget.visual === false && widget.hasOwnProperty('state')) {
				childW = widget.requireEmbeddedWidget(widget.state);

				src = (childW.isEmbedded()) ?
					childW.element[0] :
					fox.dom.selectFirst(childW.getOption('embed.container'));
			} else {
				src = widget.formElement;
			}

			location = (widget.getOption('hangClassLocation')) ? 
				widget.getOption('hangClassLocation') :
				this.getOption('hangClassLocation');

			location = fox.trim(location).split(' ');

			if (this._hangClassLocation.indexOf(location[0]) !== -1) {
				if (location.length){
					fox.each(location, function (val) {
						if (val !== 'this') {
							if (fox.dom.isDomNode(src)) {
								src = src[val];
							} else {
								throw 'Element ' + widget.getAlias() + ' is not visual.';
							}
						}
					});
				}
			} else {
				throw 'Wrong "hangClassLocation" option.';
			}

			return src;
		},

		resetElementError: function (widget) {
			var srcNodes, eCl;
			
			eCl = this.getOption('errorClass');

			srcNodes = this.getLocationNode(widget);
			if (!fox.isArray(srcNodes)) {
				srcNodes = [srcNodes];
			}

			fox.each(srcNodes, function(srcNode) {
				if (fox.dom.hasClass(this.getOption('errorClass'), srcNode)) {
					fox.dom.removeClass(eCl, srcNode);

					if (widget.getOption('exchangeErrorClass') && this.getOption('successClass')) {
						fox.dom.addClass(this.getOption('successClass'), srcNodes);
					}
				}
			}, this);
		},

		_function_submit: function () {},

		_function_formElementsCreated: function () {
			this._prepareValidators();
		},

		_function_valueChange: function (changeInfo) {
			var w = this._form.getEmbeddedWidget(changeInfo.alias);

			if (w && this._validator.validate(changeInfo.alias, changeInfo.value)) {
				this.resetElementError(w);

				this._validator._clearErrors(changeInfo.alias);
			}

			return this;
		}

	}, 'Mixin');

})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-core-resource/lib/widgets/mixin/form/easyFormValidator.js
// module id = 210
// module chunks = 0